/* unplugin-vue-components disabled */import script from "./exerciseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./exerciseCard.vue?vue&type=script&setup=true&lang=js"

import "./exerciseCard.vue?vue&type=style&index=0&id=746d5306&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-746d5306"]])

export default __exports__